export enum VatStatusEnum {
  NA = 'na',
  PASSED = 'passed',
  FAILED = 'failed',
  PENDING = 'pending',
  NOT_VERIFIED = 'not_verified'
}
